import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { FormContainer } from '$views/components/FormContainer'
import { Text, Button, Block } from '$views/components'
import {
  BannerChatNotification,
  StyledChatNotificationIcon,
  StyledChatNotificationContainer,
  StyledOptionList,
  StyledNumberList,
} from '$views/CaretakerRecommendation/Components/ChatNotification/ChatNotification.style'

const girlWithMobile = require('$icons/girlWithMobile.svg')

interface Props {
  onClick: () => void
}

export const ChatNotification: React.FC<Props> = ({ onClick }) => {
  const getBannerHeight = () => {
    return 225
  }
  return (
    <ModalWindow noPadding noHeader>
      <BannerChatNotification height={getBannerHeight()}>
        <StyledChatNotificationIcon content={girlWithMobile} height={getBannerHeight()} />
      </BannerChatNotification>
      <StyledChatNotificationContainer>
        <FormContainer>
          <Text header cooper>
            ¡Chatea y conoce!
          </Text>
          <StyledOptionList>
            <StyledNumberList header color="grey">
              1
            </StyledNumberList>
            <Block>
              <Text as="span">Ya tienes </Text>
              <Text weight="bold" as="span">
                profesionales disponibles
              </Text>
              <Text as="span"> esperándote.</Text>
            </Block>
          </StyledOptionList>
          <StyledOptionList>
            <StyledNumberList header color="grey">
              2
            </StyledNumberList>
            <Block>
              <Text as="span">Mira sus perfiles y </Text>
              <Text weight="bold" as="span">
                chatea
              </Text>
              <Text as="span"> con los que más te gusten.</Text>
            </Block>
          </StyledOptionList>
          <StyledOptionList>
            <StyledNumberList header color="grey">
              3
            </StyledNumberList>
            <Block>
              <Text as="span">Escoge el que más te guste y reserva a través de la App o queda por fuera. </Text>
              <Text weight="bold" as="span">
                Tú eliges!
              </Text>
            </Block>
          </StyledOptionList>
          <Block marginTop="medium">
            <Button primary onClick={onClick}>
              Ver profesionales
            </Button>
          </Block>
        </FormContainer>
      </StyledChatNotificationContainer>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/CaretakerRecommendation/Components/ChatNotification/ChatNotification.tsx